var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.7333V1.875C16.25 1.54348 16.1183 1.22554 15.8839 0.991117C15.6495 0.756696 15.3315 0.625 15 0.625H5C4.66848 0.625 4.35054 0.756696 4.11612 0.991117C3.8817 1.22554 3.75 1.54348 3.75 1.875V10.7333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7367 9.55423C17.8287 9.48125 17.9394 9.43568 18.0562 9.42275C18.1729 9.40981 18.2909 9.43003 18.3967 9.48109C18.5025 9.53216 18.5917 9.61199 18.6542 9.71144C18.7167 9.81089 18.7499 9.92594 18.75 10.0434V18.1267C18.75 18.4582 18.6183 18.7762 18.3839 19.0106C18.1495 19.245 17.8315 19.3767 17.5 19.3767H2.5C2.16848 19.3767 1.85054 19.245 1.61612 19.0106C1.3817 18.7762 1.25 18.4582 1.25 18.1267V10.0434C1.2501 9.92594 1.2833 9.81089 1.34579 9.71144C1.40827 9.61199 1.49752 9.53216 1.60329 9.48109C1.70907 9.43003 1.82709 9.40981 1.94383 9.42275C2.06057 9.43568 2.1713 9.48125 2.26333 9.55423L8.45583 14.4659C8.89623 14.8118 9.44001 14.9998 10 14.9998C10.56 14.9998 11.1038 14.8118 11.5442 14.4659L17.7367 9.55423Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 4.375H9.375",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.875H13.125",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 9.375H13.125",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterOpen);
export default __webpack_public_path__ + "static/media/letter-open.64b207b6be51009c6fb5ee440ef06159.svg";
export { ForwardRef as ReactComponent };